import { iframeExtensionInfo, IframeWallet } from './extension';
export const iframeWallet = new IframeWallet(iframeExtensionInfo);
//# sourceMappingURL=iframe.js.map